module.exports = __webpack_public_path__ + "static/media/zzp-ers.afe677d8.png";